// A document owns its lease; duplicated tabs and reloads get a new session id.
export function createPrintAgentBinding({ request, sessionId, readToken, schedule, cancel }) {
  let control = null;
  let lease = false;
  let timer = null;
  let generation = 0;
  let selectedToken = '';
  const clearTimer = () => { if (timer !== null) cancel(timer); timer = null; };
  const scope = () => control ? { control_token: control.control_token, profile_key: control.config.profile_key } : {};

  async function stop() {
    generation += 1;
    clearTimer();
    const wasActive = lease;
    lease = false;
    if (!wasActive) return { ok: true };
    return request('/binding/revoke', { method: 'POST', body: { session_id: sessionId } });
  }

  async function tick() {
    if (!lease) return;
    const version = generation;
    const token = readToken();
    if (!token || ['null', 'undefined'].includes(token)) { await stop(); return; }
    // The backend verifies the current user AND restaurant on every renewal.
    const result = await request('/binding/renew', { method: 'POST',
      body: { session_id: sessionId, partner_token: token } });
    if (version !== generation) return;
    if (!result.ok) { await stop(); return; }
    clearTimer();
    timer = schedule(tick, 15000);
  }

  return {
    scope,
    async select(backendUrl, partnerToken) {
      const result = await request('/binding/profile', { method: 'POST', timeoutMs: 12000,
        body: { backend_url: backendUrl, partner_token: partnerToken, session_id: sessionId } });
      if (readToken() !== partnerToken) { control = null; return { ok: false, error: 'La sesion cambio; recarga los ajustes.' }; }
      if (result.ok) { control = result; selectedToken = partnerToken; }
      else control = null;
      return result;
    },
    async activate(mode, partnerToken) {
      const version = ++generation;
      const result = await request('/binding/activate', { method: 'POST', timeoutMs: 20000,
        body: { ...scope(), mode, partner_token: partnerToken, session_id: sessionId } });
      if (result.ok && mode === 'test') {
        lease = true;
        if (version !== generation || readToken() !== partnerToken) await stop();
        else { clearTimer(); timer = schedule(tick, 15000); }
      }
      return result;
    },
    async deactivate() {
      if (lease) return stop();
      return request('/binding/revoke', { method: 'POST', timeoutMs: 12000,
        body: { ...scope(), session_id: sessionId } });
    },
    async sessionChanged(token) {
      if (selectedToken && selectedToken !== token) control = null;
      if (lease) await tick();
      return { ok: true, synchronized: false };
    },
    stop,
  };
}
